export enum ReferralVouchersQueryKeys {
  ByCode = 'referral-vouchers/by-code',
  Me = '/referral-vouchers/me',
  Main = '/referral-vouchers/main',
  Overview = '/referral-vouchers/overview/:id',
}
